import React from 'react';
import UssdComponent from './UssdComponent';

import lotteryEN from '../../assets/ussdVidoes/590 EN.mp4';
import PoolBettingEn from '../../assets/ussdVidoes/Pool Betting En.mp4';
import ScratchGameEn from '../../assets/ussdVidoes/Scratch Game En.mp4';
import SportsbettingEn from '../../assets/ussdVidoes/Sports betting En.mp4';
import RouletteEn from '../../assets/ussdVidoes/Roulette En.mp4';

function UssdInformation() {
  const ussdComponent = [
    {
      background: 'lotteryUssd',
      text: 'LOTTERY USSD GAMEPLAY',
      videoUrl: lotteryEN,
    },
    {
      background: 'sportsBetting',
      text: 'SPORTS BETTING USSD GAMEPLAY',
      videoUrl: SportsbettingEn,
    },
    {
      background: 'scratchGame',
      text: 'SCRATCH GAMES USSD GAMEPLAY',
      videoUrl: ScratchGameEn,
    },
    {
      background: 'poolBettingGame',
      text: 'POOL BETTING USSD GAMEPLAY',
      videoUrl: PoolBettingEn,
    },
    {
      background: 'rouletteGame',
      text: 'ROULETTE USSD GAMEPLAY',
      videoUrl: RouletteEn,
    },
  ];
  return <UssdComponent ussdData={ussdComponent} />;
}

export default UssdInformation;
